(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["doen-account-drawer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var RECENT_KEY = 'doen_recently_viewed';
  var SAVED_KEY = 'doen_saved_from_cart';
  var MAX_ITEMS = 8;

  function readList(key) {
    try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; }
  }

  function renderRow(root, key, sectionAttr) {
    var section = root.querySelector('[data-dacd-section="' + sectionAttr + '"]');
    var row = root.querySelector('[data-dacd-' + sectionAttr + ']');
    if (!row || !section) return 0;
    var items = readList(key).slice(0, MAX_ITEMS);
    row.innerHTML = '';
    if (!items.length) { section.hidden = true; return 0; }
    items.forEach(function (item) {
      var a = document.createElement('a');
      a.className = 'dacd__card';
      a.href = item.url;
      var img = document.createElement('img');
      img.className = 'dacd__card-img';
      img.src = item.image;
      img.loading = 'lazy';
      img.alt = item.title || '';
      var price = document.createElement('span');
      price.className = 'dacd__card-price';
      price.textContent = item.price || '';
      a.appendChild(img);
      a.appendChild(price);
      row.appendChild(a);
    });
    section.hidden = false;
    return items.length;
  }

  function populate(root) {
    var recentCount = renderRow(root, RECENT_KEY, 'recent');
    var savedCount = renderRow(root, SAVED_KEY, 'saved');
    var empty = root.querySelector('[data-dacd-empty]');
    if (empty) empty.hidden = (recentCount + savedCount) > 0;
  }

  function init(root) {
    if (root.dataset.dacdReady === '1') return;
    root.dataset.dacdReady = '1';

    function setOpen(open) {
      root.setAttribute('data-open', open ? 'true' : 'false');
      root.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) populate(root);
    }

    root.querySelectorAll('[data-dacd-close]').forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    var tabs = root.querySelectorAll('[data-dacd-tab]');
    var panels = root.querySelectorAll('[data-dacd-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-dacd-tab');
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-dacd-panel') !== target; });
      });
    });

    window.doenAccountDrawer = window.doenAccountDrawer || {};
    window.doenAccountDrawer.open = function () { setOpen(true); };
    window.doenAccountDrawer.close = function () { setOpen(false); };

    document.addEventListener('doen:account:open', function () { setOpen(true); });

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-doen-account-toggle]');
      if (!toggle) return;
      e.preventDefault();
      setOpen(true);
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-dacd]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doen-all-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(section) {
    if (section.dataset.dapReady === '1') return;
    section.dataset.dapReady = '1';

    var grid = section.querySelector('[data-dap-grid]');
    var loader = section.querySelector('[data-dap-loader]');
    var nextLink = section.querySelector('[data-dap-next]');
    if (!grid || !nextLink) return;

    var loading = false;
    var sectionId = section.dataset.section;

    function getNextUrl() {
      var link = section.querySelector('[data-dap-next]');
      return link ? link.href : null;
    }

    function loadMore() {
      if (loading) return;
      var url = getNextUrl();
      if (!url) return;

      loading = true;

      var fetchUrl = url + (url.indexOf('?') !== -1 ? '&' : '?') + 'section_id=' + sectionId;

      fetch(fetchUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-dap-grid]');
          var newNext = doc.querySelector('[data-dap-next]');

          if (newGrid) {
            var cards = newGrid.querySelectorAll('[data-dap-card]');
            var existing = grid.querySelectorAll('[data-dap-card]').length;
            cards.forEach(function (card, i) {
              var p = (existing + i) % 5;
              card.className = 'dap__card dap__card--p' + p;
              grid.appendChild(card);
            });
          }

          var oldNext = section.querySelector('[data-dap-next]');
          if (oldNext) oldNext.remove();
          var oldLoader = section.querySelector('[data-dap-loader]');

          if (newNext) {
            section.querySelector('.dap').appendChild(newNext);
          } else {
            if (oldLoader) oldLoader.remove();
          }

          loading = false;
        })
        .catch(function () { loading = false; });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadMore();
        });
      }, { rootMargin: '400px' });

      if (loader) observer.observe(loader);

      var mo = new MutationObserver(function () {
        var l = section.querySelector('[data-dap-loader]');
        if (l) observer.observe(l);
      });
      mo.observe(section, { childList: true, subtree: true });
    }
  }

  function boot(scope) {
    var ctx = scope || document;
    if (ctx.matches && ctx.matches('[data-dap]')) init(ctx);
    ctx.querySelectorAll('[data-dap]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doen-blog"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.dblgReady === '1') return;
    root.dataset.dblgReady = '1';
    var track = root.querySelector('[data-dblg-track]');
    if (!track) return;
    var prev = root.querySelector('[data-dblg-prev]');
    var next = root.querySelector('[data-dblg-next]');
    var dotsWrap = root.querySelector('[data-dblg-dots]');
    var cards = track.querySelectorAll('[data-dblg-card]');

    if (dotsWrap && cards.length) {
      cards.forEach(function (_, i) {
        var d = document.createElement('span');
        d.className = 'dblg__dot' + (i === 0 ? ' is-active' : '');
        dotsWrap.appendChild(d);
      });
    }
    var dots = dotsWrap ? dotsWrap.querySelectorAll('.dblg__dot') : [];

    function scrollByCard(dir) {
      var card = cards[0];
      if (!card) return;
      var amount = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
    if (next) next.addEventListener('click', function () { scrollByCard(1); });

    if (dots.length && cards.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var idx = Array.prototype.indexOf.call(cards, entry.target);
            dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
          }
        });
      }, { root: track, threshold: 0.6 });
      cards.forEach(function (c) { observer.observe(c); });
    }
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-dblg]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { boot(); }); } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doen-cart"] && !Shopify.designMode) return;
  try {
    
(function () {
  function saveRemovedItem(row) {
    try {
      if (!row) return;
      var entry = {
        url: row.getAttribute('data-item-url'),
        title: row.getAttribute('data-item-title'),
        image: row.getAttribute('data-item-image'),
        price: row.getAttribute('data-item-price')
      };
      if (!entry.url) return;
      var KEY = 'doen_saved_from_cart';
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      list = list.filter(function (i) { return i.url !== entry.url; });
      list.unshift(entry);
      if (list.length > 12) list = list.slice(0, 12);
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function init(root) {
    if (root.dataset.dcartReady === '1') return;
    root.dataset.dcartReady = '1';

    var form = root.querySelector('[data-dcart-form]');
    if (!form) return;

    function moneyFormat(cents) {
      return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function refreshFromCart(cart) {
      var subtotalEl = root.querySelector('[data-dcart-subtotal]');
      if (subtotalEl && typeof cart.total_price === 'number') {
        subtotalEl.textContent = subtotalEl.textContent.replace(/[\d.,]+/, moneyFormat(cart.total_price));
      }
      cart.items.forEach(function (item, idx) {
        var line = idx + 1;
        var row = root.querySelector('[data-dcart-item][data-line="' + line + '"]');
        if (!row) return;
        var totalEl = row.querySelector('[data-dcart-line-total]');
        if (totalEl) {
          totalEl.textContent = totalEl.textContent.replace(/[\d.,]+/, moneyFormat(item.final_line_price));
        }
        var input = row.querySelector('[data-dcart-qty-input]');
        if (input) input.value = item.quantity;
      });
      document.dispatchEvent(new CustomEvent('doen:cart:updated', { detail: cart }));
    }

    function changeLine(line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          if (quantity === 0) {
            var row = root.querySelector('[data-dcart-item][data-line="' + line + '"]');
            if (row) row.remove();
            if (cart.item_count === 0) window.location.reload();
          }
          refreshFromCart(cart);
        })
        .catch(function () { window.location.reload(); });
    }

    root.addEventListener('click', function (e) {
      var dec = e.target.closest('[data-dcart-decrease]');
      var inc = e.target.closest('[data-dcart-increase]');
      var rem = e.target.closest('[data-dcart-remove]');

      if (dec || inc) {
        var line = (dec || inc).getAttribute('data-line');
        var input = root.querySelector('[data-dcart-qty-input][data-line="' + line + '"]');
        if (!input) return;
        var val = parseInt(input.value, 10) || 0;
        val = dec ? Math.max(0, val - 1) : val + 1;
        input.value = val;
        changeLine(line, val);
      }

      if (rem) {
        var remLine = rem.getAttribute('data-line');
        var row = root.querySelector('[data-dcart-item][data-line="' + remLine + '"]');
        saveRemovedItem(row);
        changeLine(remLine, 0);
      }
    });

    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-dcart-qty-input]');
      if (!input) return;
      var line = input.getAttribute('data-line');
      var val = Math.max(0, parseInt(input.value, 10) || 0);
      changeLine(line, val);
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-dcart]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doen-collection-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.dclReady === '1') return;
    root.dataset.dclReady = '1';

    var track = root.querySelector('[data-dcl-track]');
    if (!track) return;

    var prev = root.querySelector('[data-dcl-prev]');
    var next = root.querySelector('[data-dcl-next]');
    var dots = root.querySelectorAll('[data-dcl-dots] .dcl__dot');
    var cards = track.querySelectorAll('[data-dcl-card]');

    function scrollByCard(dir) {
      var card = cards[0];
      if (!card) return;
      var amount = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
    if (next) next.addEventListener('click', function () { scrollByCard(1); });

    if (dots.length && cards.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var idx = Array.prototype.indexOf.call(cards, entry.target);
            dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
          }
        });
      }, { root: track, threshold: 0.6 });
      cards.forEach(function (card) { observer.observe(card); });
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-dcl]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doen-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.dcolReady === '1') return;
    root.dataset.dcolReady = '1';

    var drawer = root.querySelector('[data-dcol-drawer]');
    var open = root.querySelector('[data-dcol-open]');
    if (!drawer || !open) return;

    function set(state) {
      drawer.setAttribute('data-open', state ? 'true' : 'false');
      drawer.setAttribute('aria-hidden', state ? 'false' : 'true');
      document.documentElement.style.overflow = state ? 'hidden' : '';
    }

    open.addEventListener('click', function () { set(true); });
    drawer.querySelectorAll('[data-dcol-close]').forEach(function (el) {
      el.addEventListener('click', function () { set(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') set(false);
    });
  }

  function boot(scope) {
    var ctx = scope || document;
    if (ctx.matches && ctx.matches('[data-dcol]')) init(ctx);
    ctx.querySelectorAll('[data-dcol]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doen-customers-addresses"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.daccReady==='1')return;root.dataset.daccReady='1';
    root.querySelectorAll('[data-dacc-toggle]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var key=btn.getAttribute('data-dacc-toggle');
        var form=root.querySelector('[data-dacc-form="'+key+'"]');
        if(form)form.hidden=!form.hidden;
      });
    });
  }
  function boot(scope){(scope||document).querySelectorAll('[data-dacc]').forEach(init);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){boot();});}else{boot();}
  document.addEventListener('shopify:section:load',function(e){boot(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doen-customers-login"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.daccReady==='1')return;root.dataset.daccReady='1';
    var loginPanel=root.querySelector('[data-dacc-login-panel]');
    var recoverPanel=root.querySelector('[data-dacc-recover-panel]');
    var showRecover=root.querySelector('[data-dacc-show-recover]');
    var showLogin=root.querySelector('[data-dacc-show-login]');
    if(showRecover)showRecover.addEventListener('click',function(){loginPanel.hidden=true;recoverPanel.hidden=false;});
    if(showLogin)showLogin.addEventListener('click',function(){recoverPanel.hidden=true;loginPanel.hidden=false;});
    if(window.location.hash==='#recover')  {loginPanel.hidden=true;recoverPanel.hidden=false;}
  }
  function boot(scope){(scope||document).querySelectorAll('[data-dacc]').forEach(init);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){boot();});}else{boot();}
  document.addEventListener('shopify:section:load',function(e){boot(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doen-drawer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function saveRemovedItem(row) {
    try {
      if (!row) return;
      var entry = {
        url: row.getAttribute('data-item-url'),
        title: row.getAttribute('data-item-title'),
        image: row.getAttribute('data-item-image'),
        price: row.getAttribute('data-item-price')
      };
      if (!entry.url) return;
      var KEY = 'doen_saved_from_cart';
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      list = list.filter(function (i) { return i.url !== entry.url; });
      list.unshift(entry);
      if (list.length > 12) list = list.slice(0, 12);
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function initDrawer(root) {
    if (root.dataset.ddrReady === '1') return;
    root.dataset.ddrReady = '1';

    function setOpen(open) {
      root.setAttribute('data-open', open ? 'true' : 'false');
      root.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }

    root.querySelectorAll('[data-ddr-close]').forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    function moneyFormat(cents) {
      return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function refreshFromCart(cart) {
      var subtotalEl = root.querySelector('[data-ddr-subtotal]');
      if (subtotalEl && typeof cart.total_price === 'number') {
        subtotalEl.textContent = subtotalEl.textContent.replace(/[\d.,]+/, moneyFormat(cart.total_price));
      }
      cart.items.forEach(function (item, idx) {
        var line = idx + 1;
        var row = root.querySelector('[data-ddr-item][data-line="' + line + '"]');
        if (!row) return;
        var totalEl = row.querySelector('[data-ddr-line-total]');
        if (totalEl) totalEl.textContent = totalEl.textContent.replace(/[\d.,]+/, moneyFormat(item.final_line_price));
        var qtyEl = row.querySelector('[data-ddr-qty-value]');
        if (qtyEl) qtyEl.textContent = item.quantity;
      });
      document.dispatchEvent(new CustomEvent('doen:cart:updated', { detail: cart }));
    }

    function refreshDrawer() {
      var wrapper = root.closest('[id^="shopify-section-"]');
      if (!wrapper) return;
      var sectionId = wrapper.id.replace('shopify-section-', '');
      /*
       * Fetch the CURRENT page URL (not a hardcoded '/'), so this keeps
       * working when previewing an unpublished theme (?preview_theme_id=...),
       * on a locale-prefixed storefront (/en-ca/...), or behind any other
       * query-string context. Fetching '/' unconditionally could silently
       * hit a different theme/page and no-op the whole refresh.
       */
      var url = new URL(window.location.href);
      url.searchParams.set('section_id', sectionId);
      fetch(url.toString())
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newBody = doc.querySelector('[data-ddr-body]');
          var newFoot = doc.querySelector('.ddr__foot');
          var oldBody = root.querySelector('[data-ddr-body]');
          var oldFoot = root.querySelector('.ddr__foot');
          if (newBody && oldBody) oldBody.replaceWith(newBody);
          if (newFoot && oldFoot) {
            /* Footer already exists (cart already had items) - swap it in place. */
            oldFoot.replaceWith(newFoot);
          } else if (newFoot && !oldFoot) {
            /* Cart just went from empty to non-empty: the "cart has items"
               footer (Checkout / View Bag) never rendered on first page load, so
               there is nothing to replace it - it has to be inserted fresh. */
            var panel = root.querySelector('.ddr__panel');
            if (panel) panel.appendChild(newFoot);
          } else if (!newFoot && oldFoot) {
            /* Cart just went from non-empty to empty (last item removed). */
            oldFoot.remove();
          }
        })
        .catch(function () {});
    }

    function changeLine(line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          refreshFromCart(cart);
          if (quantity === 0 || cart.item_count === 0) refreshDrawer();
        })
        .catch(function () {});
    }

    root.addEventListener('click', function (e) {
      var dec = e.target.closest('[data-ddr-decrease]');
      var inc = e.target.closest('[data-ddr-increase]');
      var rem = e.target.closest('[data-ddr-remove]');

      if (dec || inc) {
        var line = (dec || inc).getAttribute('data-line');
        var valueEl = root.querySelector('[data-ddr-qty-value][data-line="' + line + '"]');
        if (!valueEl) return;
        var val = parseInt(valueEl.textContent, 10) || 0;
        val = dec ? Math.max(0, val - 1) : val + 1;
        valueEl.textContent = val;
        changeLine(line, val);
      }

      if (rem) {
        var remLine = rem.getAttribute('data-line');
        var row = root.querySelector('[data-ddr-item][data-line="' + remLine + '"]');
        saveRemovedItem(row);
        changeLine(remLine, 0);
      }
    });

    window.doenCartDrawer = window.doenCartDrawer || {};
    window.doenCartDrawer.open = function () { refreshDrawer(); setOpen(true); };
    window.doenCartDrawer.close = function () { setOpen(false); };

    document.addEventListener('doen:cart:open', function () {
      refreshDrawer();
      setOpen(true);
    });

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-doen-cart-toggle]');
      if (!toggle) return;
      e.preventDefault();
      refreshDrawer();
      setOpen(true);
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ddr]').forEach(initDrawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doen-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.dfaqReady === '1') return;
    root.dataset.dfaqReady = '1';

    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-dfaq-row]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-dfaq-group]'));
    var search = root.querySelector('[data-dfaq-search]');
    var empty = root.querySelector('[data-dfaq-empty]');
    var single = root.dataset.single === 'true';

    if (single) {
      rows.forEach(function (row) {
        row.addEventListener('toggle', function () {
          if (!row.open) return;
          rows.forEach(function (other) {
            if (other !== row && other.open) other.open = false;
          });
        });
      });
    }

    if (!search) return;

    function apply() {
      var q = search.value.trim().toLowerCase();
      var shown = 0;

      rows.forEach(function (row) {
        var hit = !q || (row.dataset.text || '').indexOf(q) !== -1;
        row.hidden = !hit;
        if (hit) shown++;
        if (!hit && row.open) row.open = false;
      });

      groups.forEach(function (group) {
        var hasVisible = false;
        var node = group.nextElementSibling;
        while (node && !node.hasAttribute('data-dfaq-group')) {
          if (node.hasAttribute('data-dfaq-row') && !node.hidden) { hasVisible = true; break; }
          node = node.nextElementSibling;
        }
        group.hidden = q ? !hasVisible : false;
      });

      if (empty) empty.hidden = shown !== 0;
    }

    var t;
    search.addEventListener('input', function () {
      window.clearTimeout(t);
      t = window.setTimeout(apply, 120);
    });

    search.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { search.value = ''; apply(); }
    });
  }

  function boot(scope) {
    var ctx = scope || document;
    if (ctx.matches && ctx.matches('[data-dfaq]')) init(ctx);
    ctx.querySelectorAll('[data-dfaq]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doen-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.dhReady==='1')return;root.dataset.dhReady='1';
    var drawer=root.querySelector('[data-dh-drawer]');var openBtn=root.querySelector('[data-dh-open]');
    if(drawer&&openBtn){
      function set(open){drawer.setAttribute('data-open',open?'true':'false');drawer.setAttribute('aria-hidden',open?'false':'true');openBtn.setAttribute('aria-expanded',open?'true':'false');document.documentElement.style.overflow=open?'hidden':'';}
      openBtn.addEventListener('click',function(){set(true)});
      drawer.querySelectorAll('[data-dh-close]').forEach(function(el){el.addEventListener('click',function(){set(false)})});
      document.addEventListener('keydown',function(e){if(e.key==='Escape')set(false)});
    }

    /* Mega menu hover-intent: keeps the panel open while the cursor
       transits the gap between the trigger and the (edge-to-edge)
       panel, instead of closing the instant plain CSS :hover is lost. */
    var closeTimers = new WeakMap();
    var OPEN_DELAY = 40;
    var CLOSE_DELAY = 260;

    function openMega(mega){
      var t = closeTimers.get(mega);
      if(t) { clearTimeout(t); closeTimers.delete(mega); }
      mega.classList.add('is-open');
    }
    function scheduleClose(mega){
      var existing = closeTimers.get(mega);
      if(existing) clearTimeout(existing);
      var t = setTimeout(function(){
        mega.classList.remove('is-open');
        closeTimers.delete(mega);
      }, CLOSE_DELAY);
      closeTimers.set(mega, t);
    }

    root.querySelectorAll('.dh__mega').forEach(function(mega){
      var panel = mega.querySelector('.dh__panel');
      mega.addEventListener('mouseenter', function(){ openMega(mega); });
      mega.addEventListener('mouseleave', function(){ scheduleClose(mega); });
      if(panel){
        panel.addEventListener('mouseenter', function(){ openMega(mega); });
        panel.addEventListener('mouseleave', function(){ scheduleClose(mega); });
      }
      mega.addEventListener('focusin', function(){ openMega(mega); });
      mega.addEventListener('focusout', function(e){
        if(!mega.contains(e.relatedTarget)) scheduleClose(mega);
      });
    });
  }
  function boot(scope){(scope||document).querySelectorAll('[data-dh]').forEach(init)}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){boot()})}else{boot()}
  document.addEventListener('shopify:section:load',function(e){boot(e.target)});
  /* Random editorial image on mega hover */
  document.addEventListener('mouseenter',function(e){
    var mega=e.target.closest&&e.target.closest('.dh__mega');
    if(!mega)return;
    var wrap=mega.querySelector('[data-dh-random-media]');
    if(!wrap)return;
    var imgs=wrap.querySelectorAll('[data-dh-rimg]');
    if(imgs.length<2)return;
    var current=wrap.querySelector('[data-dh-rimg].is-active');
    var pool=[];imgs.forEach(function(el){if(el!==current)pool.push(el)});
    var next=pool[Math.floor(Math.random()*pool.length)];
    imgs.forEach(function(el){el.classList.remove('is-active')});
    next.classList.add('is-active');
  },true);

  /* Live cart badge: creates/updates/removes the count bubble on any
     cart change, instead of relying on a full page reload to re-render
     the server-side {{ cart.item_count }} value. */
  document.addEventListener('doen:cart:updated', function (e) {
    var cart = e.detail;
    if (!cart || typeof cart.item_count === 'undefined') return;
    document.querySelectorAll('[data-doen-cart-toggle]').forEach(function (link) {
      var wrap = link.querySelector('.dh__icon-wrap');
      if (!wrap) return;
      var badge = wrap.querySelector('.dh__count');
      if (cart.item_count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'dh__count';
          wrap.appendChild(badge);
        }
        badge.textContent = cart.item_count;
      } else if (badge) {
        badge.remove();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doen-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.dheroReady === '1') return;
    root.dataset.dheroReady = '1';

    var videos = root.querySelectorAll('video');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (v) { v.play().catch(function () {}); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          v.play().catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.15 });

    videos.forEach(function (v) {
      v.muted = true;
      v.setAttribute('playsinline', '');
      io.observe(v);
    });
  }

  function boot(scope) {
    var ctx = scope || document;
    if (ctx.matches && ctx.matches('[data-dhero]')) init(ctx);
    ctx.querySelectorAll('[data-dhero]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doen-post"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.dpostReady === '1') return;
    root.dataset.dpostReady = '1';
    var copyBtn = root.querySelector('[data-dpost-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var url = window.location.href;
        function done() {
          copyBtn.setAttribute('data-copied', '1');
          setTimeout(function () { copyBtn.removeAttribute('data-copied'); }, 1600);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(function () {});
        } else {
          var t = document.createElement('textarea');
          t.value = url;
          document.body.appendChild(t);
          t.select();
          try { document.execCommand('copy'); done(); } catch (e) {}
          document.body.removeChild(t);
        }
      });
    }
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-dpost]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { boot(); }); } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doen-product"] && !Shopify.designMode) return;
  try {
    
(function(){function init(root){if(root.dataset.dpdpReady==='1')return;root.dataset.dpdpReady='1';var tabsWrap=root.querySelector('[data-dpdp-tabs]');if(tabsWrap){var btns=tabsWrap.querySelectorAll('[data-dpdp-tab]');var panels=tabsWrap.querySelectorAll('[data-dpdp-panel]');btns.forEach(function(b){b.addEventListener('click',function(){btns.forEach(function(x){x.classList.remove('is-active');x.setAttribute('aria-selected','false')});panels.forEach(function(p){p.classList.remove('is-active')});b.classList.add('is-active');b.setAttribute('aria-selected','true');var t=tabsWrap.querySelector('[data-dpdp-panel="'+b.dataset.dpdpTab+'"]');if(t)t.classList.add('is-active')})})}
var save=root.querySelector('[data-dpdp-save]');if(save){save.addEventListener('click',function(){var on=save.getAttribute('aria-pressed')==='true';save.setAttribute('aria-pressed',on?'false':'true')})}
var form=root.querySelector('[data-dpdp-form]');var data=root.querySelector('[data-dpdp-variants]');if(!form||!data)return;var variants;try{variants=JSON.parse(data.textContent)}catch(e){return}if(!variants||!variants.length)return;
var idInput=root.querySelector('[data-dpdp-id]');var priceEl=root.querySelector('[data-dpdp-price]');var compareEl=root.querySelector('[data-dpdp-compare]');var labelEl=root.querySelector('[data-dpdp-variant-label]');var buy=root.querySelector('[data-dpdp-buy]');var buyText=root.querySelector('[data-dpdp-buy-text]');var sizeInputs=root.querySelectorAll('[data-dpdp-size]');var optionInputs=root.querySelectorAll('[data-dpdp-option]');
function money(cents){try{var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';return(cents/100).toLocaleString(undefined,{style:'currency',currency:cur})}catch(e){return(cents/100).toFixed(2)}}
function chosen(){var out={};optionInputs.forEach(function(i){if(i.checked)out[i.dataset.dpdpOption]=i.value});return out}
function match(sel){var keys=Object.keys(sel);return variants.find(function(v){return keys.every(function(k){return v.options[parseInt(k,10)]===sel[k]})})}
function sizeChosen(){if(!sizeInputs.length)return true;for(var i=0;i<sizeInputs.length;i++)if(sizeInputs[i].checked)return true;return false}
function setBuy(state){if(!buy||!buyText)return;if(state==='select'){buyText.textContent=buy.dataset.labelSelect;buy.disabled=false}else if(state==='add'){buyText.textContent=buy.dataset.labelAdd;buy.disabled=false}else{buyText.textContent=buy.dataset.labelSold;buy.disabled=true}}
function refresh(){var sel=chosen();var v=match(sel);if(v){if(idInput)idInput.value=v.id;if(priceEl)priceEl.textContent=money(v.price);if(compareEl)compareEl.textContent=v.compare_at_price&&v.compare_at_price>v.price?money(v.compare_at_price):'';if(labelEl&&v.title&&v.title!=='Default Title'){labelEl.textContent=(labelEl.dataset.prefix||'')+' '+v.title.split(' / ')[0]}var sgV=document.querySelector('[data-dsg-variant]');if(sgV&&v.title&&v.title!=='Default Title'){sgV.textContent=v.title.split(' / ')[0]}}if(!sizeChosen()){setBuy('select');return}if(!v||!v.available){setBuy('sold');return}setBuy('add')}
function refreshSizeAvailability(){var sel=chosen();sizeInputs.forEach(function(input){var probe={};Object.keys(sel).forEach(function(k){probe[k]=sel[k]});probe[input.dataset.dpdpOption]=input.value;var v=match(probe);input.disabled=!(v&&v.available)})}
optionInputs.forEach(function(i){i.addEventListener('change',function(){refreshSizeAvailability();refresh()})});refreshSizeAvailability();refresh();
form.addEventListener('submit',function(e){if(!sizeChosen()){e.preventDefault();var sizes=root.querySelector('[data-dpdp-sizes]');if(sizes){sizes.scrollIntoView({behavior:'smooth',block:'center'});var first=sizes.querySelector('input:not(:disabled)');if(first)first.focus()}return}e.preventDefault();var original=buyText?buyText.textContent:'';if(buy)buy.disabled=true;if(buyText)buyText.textContent='Adding...';fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:idInput.value,quantity:1})}).then(function(r){if(!r.ok)throw new Error('add failed');return r.json()}).then(function(){if(buyText)buyText.textContent='Added';document.dispatchEvent(new CustomEvent('dpdp:added'));fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){document.dispatchEvent(new CustomEvent('doen:cart:updated',{detail:cart}))}).catch(function(){});if(window.doenCartDrawer&&typeof window.doenCartDrawer.open==='function'){window.doenCartDrawer.open()}else{document.dispatchEvent(new CustomEvent('doen:cart:open'))}setTimeout(function(){if(buyText)buyText.textContent=original;if(buy)buy.disabled=false},1400)}).catch(function(){if(buyText)buyText.textContent=original;if(buy)buy.disabled=false;form.submit()})})}
function boot(scope){var ctx=scope||document;if(ctx.matches&&ctx.matches('[data-dpdp]'))init(ctx);ctx.querySelectorAll('[data-dpdp]').forEach(init)}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){boot()})}else{boot()}document.addEventListener('shopify:section:load',function(e){boot(e.target)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doen-search-drawer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function highlight(text, query) {
    var idx = text.toLowerCase().indexOf(query.toLowerCase());
    if (idx === -1) return text;
    return text.slice(0, idx) + '<b>' + text.slice(idx, idx + query.length) + '</b>' + text.slice(idx + query.length);
  }

  function init(root) {
    if (root.dataset.dsdrReady === '1') return;
    root.dataset.dsdrReady = '1';

    var input = root.querySelector('[data-dsdr-input]');
    var resultsWrap = root.querySelector('[data-dsdr-results]');
    var suggestionsCol = root.querySelector('[data-dsdr-suggestions-col]');
    var suggestionsList = root.querySelector('[data-dsdr-suggestions]');
    var pagesCol = root.querySelector('[data-dsdr-pages-col]');
    var pagesList = root.querySelector('[data-dsdr-pages]');
    var productsWrap = root.querySelector('[data-dsdr-products-wrap]');
    var productsGrid = root.querySelector('[data-dsdr-products]');
    var emptyEl = root.querySelector('[data-dsdr-empty]');

    function setOpen(open) {
      root.setAttribute('data-open', open ? 'true' : 'false');
      root.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open && input) setTimeout(function () { input.focus(); }, 80);
    }

    root.querySelectorAll('[data-dsdr-close]').forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-doen-search-toggle]');
      if (!toggle) return;
      e.preventDefault();
      setOpen(true);
    });

    function clearResults() {
      resultsWrap.hidden = true;
      suggestionsCol.hidden = true;
      pagesCol.hidden = true;
      productsWrap.hidden = true;
      emptyEl.hidden = true;
      suggestionsList.innerHTML = '';
      pagesList.innerHTML = '';
      productsGrid.innerHTML = '';
    }

    function runSearch(query) {
      if (!query) { clearResults(); return; }

      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,page,query&resources[limit]=10&resources[options][fields]=title,product_type,variants.title')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var results = (data && data.resources && data.resources.results) || {};
          var queries = results.queries || [];
          var pages = results.pages || [];
          var products = results.products || [];

          var any = queries.length || pages.length || products.length;
          resultsWrap.hidden = !any;
          emptyEl.hidden = !!any;
          if (!any) return;

          suggestionsList.innerHTML = '';
          if (queries.length) {
            queries.forEach(function (q) {
              var li = document.createElement('li');
              var a = document.createElement('a');
              a.href = '/search?q=' + encodeURIComponent(q.text) + '&type=product';
              a.innerHTML = highlight(q.text, query);
              li.appendChild(a);
              suggestionsList.appendChild(li);
            });
            suggestionsCol.hidden = false;
          } else {
            suggestionsCol.hidden = true;
          }

          pagesList.innerHTML = '';
          if (pages.length) {
            pages.forEach(function (p) {
              var li = document.createElement('li');
              var a = document.createElement('a');
              a.href = p.url;
              a.textContent = p.title;
              li.appendChild(a);
              pagesList.appendChild(li);
            });
            pagesCol.hidden = false;
          } else {
            pagesCol.hidden = true;
          }

          productsGrid.innerHTML = '';
          if (products.length) {
            products.forEach(function (p) {
              var a = document.createElement('a');
              a.className = 'dsdr__product';
              a.href = p.url;
              var media = document.createElement('span');
              media.className = 'dsdr__product-media';
              if (p.featured_image && p.featured_image.url) {
                var img = document.createElement('img');
                img.className = 'dsdr__product-img';
                img.src = p.featured_image.url;
                img.loading = 'lazy';
                img.alt = p.title;
                media.appendChild(img);
              }
              var titleEl = document.createElement('span');
              titleEl.className = 'dsdr__product-title';
              titleEl.textContent = p.title;
              a.appendChild(media);
              a.appendChild(titleEl);
              productsGrid.appendChild(a);
            });
            productsWrap.hidden = false;
          } else {
            productsWrap.hidden = true;
          }
        })
        .catch(function () {});
    }

    var debounced = debounce(function () {
      runSearch(input.value.trim());
    }, 220);

    if (input) {
      input.addEventListener('input', debounced);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var q = input.value.trim();
          if (q) window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
        }
      });
    }

    var submit = root.querySelector('[data-dsdr-submit]');
    if (submit) {
      submit.addEventListener('click', function () {
        var q = input.value.trim();
        if (q) window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
      });
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-dsdr]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doen-size-guide"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSG(root) {
    if (root.dataset.dsgReady === '1') return;
    root.dataset.dsgReady = '1';
    var sgId = root.dataset.dsgId;
    document.querySelectorAll('[data-open-sizeguide="' + sgId + '"],[data-open-sizeguide="any"]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        root.hidden = false;
        requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
        document.body.style.overflow = 'hidden';
        var x = root.querySelector('.dsg__x');
        if (x) x.focus();
      });
    });
    function close() {
      root.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { root.hidden = true; }, 320);
    }
    root.querySelectorAll('[data-dsg-close]').forEach(function (el) { el.addEventListener('click', close); });
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    var pillWrap = root.querySelector('[data-dsg-pills]');
    if (pillWrap) {
      var pills = pillWrap.querySelectorAll('[data-dsg-pill]');
      var groupBlocks = root.querySelectorAll('[data-dsg-group]');
      function showGroup(num) {
        groupBlocks.forEach(function (b) {
          var g = b.dataset.dsgGroup;
          if (g === '0') { b.classList.remove('is-hidden'); return; }
          b.classList.toggle('is-hidden', g !== num);
        });
      }
      pills.forEach(function (p) {
        p.addEventListener('click', function () {
          pills.forEach(function (x) { x.classList.remove('is-active'); });
          p.classList.add('is-active');
          showGroup(p.dataset.dsgPill);
        });
      });
      showGroup('1');
    }
  }
  function boot(scope) {
    var ctx = scope || document;
    ctx.querySelectorAll('[data-dsg]').forEach(initSG);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { boot(); }); } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-dpdp-option]')) {
      setTimeout(function () {
        var label = document.querySelector('[data-dpdp-variant-label]');
        var sgLabel = document.querySelector('[data-dsg-variant]');
        if (label && sgLabel) { sgLabel.textContent = label.textContent.replace(/^(In|En)\s*/i, ''); }
      }, 50);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doen-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.dvidReady === '1') return;
    root.dataset.dvidReady = '1';

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var wantAutoplay = root.dataset.autoplay === 'true' && !reduced;
    var pauseOffscreen = root.dataset.pauseOffscreen === 'true';
    var toggle = root.querySelector('[data-dvid-toggle]');

    function visibleVideo() {
      var vids = root.querySelectorAll('video');
      for (var i = 0; i < vids.length; i++) {
        if (vids[i].offsetParent !== null) return vids[i];
      }
      return vids[0] || null;
    }

    var videos = root.querySelectorAll('video');
    if (!videos.length) {
      if (toggle) toggle.style.display = 'none';
      return;
    }

    videos.forEach(function (v) {
      v.muted = true;
      v.setAttribute('playsinline', '');
      if (!wantAutoplay) v.removeAttribute('autoplay');
    });

    function setState(playing) {
      if (!toggle) return;
      toggle.dataset.state = playing ? 'playing' : 'paused';
      toggle.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    }

    if (pauseOffscreen && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (v.offsetParent === null) return;
          if (entry.isIntersecting) {
            if (wantAutoplay && v.dataset.userPaused !== '1') {
              v.play().then(function () { setState(true); }).catch(function () {});
            }
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: 0.2 });
      videos.forEach(function (v) { io.observe(v); });
    } else if (wantAutoplay) {
      videos.forEach(function (v) {
        v.play().then(function () { setState(true); }).catch(function () {});
      });
    }

    if (!wantAutoplay) setState(false);

    if (toggle) {
      toggle.addEventListener('click', function () {
        var v = visibleVideo();
        if (!v) return;
        if (v.paused) {
          v.dataset.userPaused = '0';
          v.play().then(function () { setState(true); }).catch(function () {});
        } else {
          v.dataset.userPaused = '1';
          v.pause();
          setState(false);
        }
      });
    }
  }

  function boot(scope) {
    var ctx = scope || document;
    if (ctx.matches && ctx.matches('[data-dvid]')) init(ctx);
    ctx.querySelectorAll('[data-dvid]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
